import React, { useState } from "react";
import { PropertyDescProps } from "./property-description.interface";
import styles from "../property-description/property-description.module.scss";
import { ViewMore } from "../../investor/amplitude";
import { useParams, useSearchParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import useContextHook from "../../../hooks/context/useContext";
const ShowPropertyDetails = ({
  propertyDetails,
  viewMoreWords,
  type
}: PropertyDescProps) => {
  const { propertyId } = useParams();
  const [showMore, setShowMore] = useState(false);
  const queryClient = useQueryClient();
  const [searchParams] = useSearchParams();
  const cid = searchParams.get("cid") || "";
  const eq = searchParams.get("eq") || "";
  const { mobileNumber } = useContextHook();
  const handleShowMore = () => {
    setShowMore((prev) => !prev);
  };

  return (
    <>
      {showMore
        ? propertyDetails
        : propertyDetails?.length > 0
        ? `${propertyDetails?.substring(0, viewMoreWords)} ${
            !showMore &&
            propertyDetails?.description?.length > (viewMoreWords || 0)
              ? "..."
              : ""
          }`
        : "-"}

      <button
        tabIndex={15}
        type="button"
        className={styles.viewMore}
        onClick={() => {
          handleShowMore();
          if (type === "investor") {
            const investorPropertyDetail: any = queryClient.getQueryData([
              "investor-Property-Detail",
              propertyId
            ]);
            ViewMore({
              propertySFID: investorPropertyDetail?.data?.propertySFID,
              propertyId: investorPropertyDetail?.data?.id,
              shareId: propertyId || "",
              pubPropertySFID: investorPropertyDetail?.data?.pubPropertySFID,
              opportunitySFID: investorPropertyDetail?.data?.opportunitySFID,
              linkCId: cid,
              linkEmailId: eq,
              ...(mobileNumber && { mobileNumber: mobileNumber })
            });
          }
        }}
        // onClick={handleShowMore}
      >
        {showMore
          ? "View less"
          : propertyDetails?.length > (viewMoreWords || 0)
          ? "View more"
          : ""}
      </button>
    </>
  );
};

const PropertyDesc = ({
  title,
  propertyDetails,
  viewMoreWords,
  Notes,
  type
}: PropertyDescProps) => {
  return (
    <div className={styles.propertyDesc} tabIndex={13}>
      <div className={`${styles.title} ${Notes && styles.Notes}`} tabIndex={14}>
        {title}
      </div>
      <span className={`${styles.descText} ${Notes && styles.Notes}`}>
        <ShowPropertyDetails
          type={type}
          propertyDetails={propertyDetails}
          viewMoreWords={viewMoreWords}
        />
      </span>
    </div>
  );
};

export default React.memo(PropertyDesc);
